
module Shared {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

    // More info: http://frhagn.github.io/Typewriter/

    
    export class Location  {
        
        // STARTDATE
        public startDate: Date = null;
        // EXPECTEDENDDATE
        public expectedEndDate: Date = null;
        // LASTDAYONSITE
        public lastDayOnSite: Date = null;
        // SITENAME
        public siteName: string = null;
        // ADDRESS1
        public address1: string = null;
        // ADDRESS2
        public address2: string = null;
        // ADDRESS3
        public address3: string = null;
        // CITY
        public city: string = null;
        // COUNTY
        public county: string = null;
        // POSTCODE
        public postCode: string = null;
    }
}
